// extracted by mini-css-extract-plugin
export var mcpAddContract = "mcp-add-contract_yca76LFApcoPwr1DZ8sO";
export var mcpAddContractError = "mcp-add-contract__error_Vs71aPRCvDU0gebd43HR";